export default "__VITE_ASSET__CVQSSoiJ__"